(() => {
 const box=document.querySelector('[data-da-letter]'); if(!box||box.dataset.ready)return;box.dataset.ready='true';
 const key='da-choco-letter-dismissed-v1',days=Number(box.dataset.days)||14; let dismissed=false,ready=false;
 const close=()=>{box.hidden=true;dismissed=true;try{localStorage.setItem(key,String(Date.now()+days*86400000))}catch(e){}};
 box.querySelector('[data-letter-close]').addEventListener('click',close);
 document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!box.hidden){close()}});
 if(box.querySelector('[data-letter-success]')){try{localStorage.setItem(key,String(Date.now()+365*86400000))}catch(e){}box.hidden=false;return;}
 try{if(Number(localStorage.getItem(key))>Date.now())return;}catch(e){}
 if(window.Shopify&&Shopify.designMode){box.hidden=false;return;}
 const show=()=>{if(!ready||dismissed||!box.hidden||document.visibilityState!=='visible')return;
  if(document.activeElement&&document.activeElement.matches('input,textarea,select'))return;
  if(document.querySelector('dialog[open],.menu-drawer-container[open],details-modal details[open],.shopify-section-header-hidden[aria-expanded="true"]'))return;
  const inline=document.querySelector('.da-letter--inline'); if(inline){const rect=inline.getBoundingClientRect();if(rect.top<innerHeight&&rect.bottom>0)return;}
  const height=document.documentElement.scrollHeight-innerHeight;
  if(height>0&&scrollY/height<0.25)return;
  box.hidden=false;
 };
 setTimeout(()=>{ready=true;show()},(Number(box.dataset.delay)||35)*1000);
 addEventListener('scroll',show,{passive:true});document.addEventListener('visibilitychange',show);
})();
